module.exports = __webpack_public_path__ + "static/media/wtof-2.63bd45bc.JPG";